import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  ReferenceBook,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const api = createApi({
  reducerPath: 'departmentsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/departments`,
  }),
  tagTypes: ['Department'],
  endpoints: builder => ({
    getDepartments: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['Department'],
    }),
    getDepartmentsI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Department'],
    }),
  }),
});

export const departmentsApi = api;

export const { useGetDepartmentsQuery } = api;

export const useGetDepartmentsInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetDepartmentsIInfiniteQuery,
);
